import { isNil } from 'lodash';
import {
    DEMO_VIDEO_WATCHED_LOCAL_STORAGE_FLAG,
    MIC_PERMISSION_STATUSES,
} from './TROInstructionsConstants';
import {
    setItemToLocalStorage,
    getItemFromLocalStorage,
} from '../../../common/persistence/persistanceUtils';

export const isMicPermissionDenied = status => MIC_PERMISSION_STATUSES.DENIED === status;

export const isMicPermissionGranted = status => MIC_PERMISSION_STATUSES.GRANTED === status;

export let getMicPermissionStatus = async () => {
    let permissionsStatus = null;
    if (navigator.permissions) {
        permissionsStatus = await navigator.permissions.query({ name: 'microphone' });
    }

    return permissionsStatus;
};

export let getAudioStream = async () => {
    let stream;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    }

    return stream;
};

export let getDemoVideoLocalStorageUserKey = (userId, grade, period) =>
    `${DEMO_VIDEO_WATCHED_LOCAL_STORAGE_FLAG}-${userId}-${grade}-${period}`;

export const isDemoVideoAlreadyWatched = (userId, grade, period) =>
    !isNil(getItemFromLocalStorage(getDemoVideoLocalStorageUserKey(userId, grade, period)));

export const setWatchedDemoVideoFlagToLocalStorage = (userId, grade, period) =>
    setItemToLocalStorage(getDemoVideoLocalStorageUserKey(userId, grade, period), true);
